import React from 'react';
import { Player } from 'video-react';
import "../../../node_modules/video-react/dist/video-react.css";
import C1 from '../images/Experience/Carter1.m4v';
import C2 from '../images/Experience/Carter2.m4v';
import CarterMore from '../PhotoShow/CarterMore';


import { column, row, leftRow, seeMoreButton, halfImage } from '../../app/styles';


class Experience extends React.Component {

    constructor() {
        super();
        this.state = {
            moreShow: false,
        }
    }

    render() {
        return (
            <div style={column}>
                <div style={column}>
                    <h3 style={{margin:0}}>Not Including Personal Builds & Projects</h3>
                </div>
                <h2 style={{margin:0, width:'77%'}}>Carter Construction | Subcontractor - Boise, ID</h2>
                <h4 style={{margin:0, width:'77%'}}>June 2018 – Sept 2018</h4>
                <div style={leftRow}>
                    <p>
                        I was part of a crew contracted to build an 1800 square foot deck. From the ground up we poured concrete, set up a frame, and started laying decking material. Later we added a 160 square foot roof in the center, as well as a hot tub pad.
                    </p>
                </div>
                <div style={row}>
                <div style={halfImage}>
                    <Player
                        playsInline
                        poster="/assets/poster.png"
                        src={C1}
                        />
                    </div>
                    <div style={{width:'40px'}}></div>
                    <div style={halfImage}>
                    <Player
                        playsInline
                        poster="/assets/poster.png"
                        src={C2}
                        />
                    </div>
                </div>
                <div style={{display:"flex", width:'77%', justifyContent:"center", textAlign:"center", marginBottom:"20px"}}>
                    <p style={{margin:"0px", width:"35%"}}>
                        A walkaround of the entire deck. We had already laid decking around most of the house, and were working on the large section at the back.
                    </p>
                    <div style={{width:'20px'}}></div>
                    <p style={{margin:"0px", width:"35%"}}>
                        Placing the beams for the patio roof in the middle of the main portion of the deck. Each beam was approximately 120 lbs.
                    </p>                    
                </div>
                <div style={row}>
                    <button style={seeMoreButton} onClick={() => {
                            this.setState({moreShow: !this.state.moreShow});
                        }}>
                            Click to see pictures from the job
                    </button>
                </div>
                {this.state.moreShow ? (
                    <>
                        <CarterMore />
                        <button style={seeMoreButton} onClick={() => {
                            this.setState({ moreShow: !this.state.moreShow });
                        }}>
                            Close
                        </button>
                    </>)
                    : <></>}

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>

                <h2 style={{margin:0}}>Safeway | Front End Clerk - Cheney, WA</h2>
                <h4 style={{margin:0, width:'77%'}}>November 2018 - Current</h4>
                <div style={leftRow}>
                    <p>
                        My primary job at Safeway is Customer Service. I also am tasked with ensuring a safe environment for Safeway customers and employees, among many other things.
                    </p>
                </div>

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>

                <h2 style={{margin:0}}>Les Schwab | Sales and Service - Cheney, WA</h2>
                <h4 style={{margin:0, width:'77%'}}>June 2017 – June 2018</h4>
                <div style={leftRow}>
                    <p>
                    Provided exceptional customer service to an average of 30+ customers a day. I greeted customers, listened to their needs, suggested solutions, invoiced work, and ensured satisfaction.
                    </p>
                </div>

                <div style={{ width: '77%', color: 'white' }}>
                    <hr></hr>
                </div>

                <h2 style={{margin:0}}>Teachers Assistant | Woodinville High School CAD - Woodinville, WA</h2>
                <h4 style={{margin:0, width:'77%'}}>2013 - 2014</h4>
                <div style={leftRow}>
                    <p>
                    I aided in the development of 30 student’s 3D CAD (computer automated design) skills. I answered questions, developed future lesson plans, edited current lesson plans,
                    repaired the classroom’s three 3D printers. For the Maker Bot Replicator, I diagnosed printer issues, identified replacement parts, and replaced broken/worn components
                    </p>
                </div>
            </div>
        );
    }
}

export default Experience;